import { put, takeLeading } from 'redux-saga/effects';

import { toast } from 'react-toastify';

import manageAccountApi from 'api/manageAccount';
import { apiErrorHandler } from 'utils';

import {
  GET_INTERNAL_ACCOUNT_LIST,
  CREATE_INTERNAL_ACCOUNT,
  UPDATE_INTERNAL_ACCOUNT,
  GET_INTERNAL_ACCOUNT_DETAIL,
  DELETE_INTERNAL_ACCOUNT,
} from './actionTypes';

import {
  actionGetInternalAccountListSuccess,
  actionGetInternalAccountListFailed,
  actionCreateInternalAccountSuccess,
  actionCreateInternalAccountFailed,
  actionUpdateInternalAccountSuccess,
  actionUpdateInternalAccountFailed,
  actionGetInternalAccountDetailSuccess,
  actionGetInternalAccountDetailFailed,
  actionDeleteInternalAccountSuccess,
  actionDeleteInternalAccountFailed,
} from './actions';

function* getInternalAccountList({ payload }) {
  const { append, ...apiPayload } = payload || {};

  try {
    const response = yield manageAccountApi.getInternalAccountList(apiPayload);

    yield put(
      actionGetInternalAccountListSuccess({
        ...response.payload,
        append: !!append,
      }),
    );
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetInternalAccountListFailed());
  }
}

function* createInternalAccount({ payload }) {
  const { accountInfo, callback } = payload;
  try {
    yield manageAccountApi.createInternalAccount(accountInfo);
    yield put(actionCreateInternalAccountSuccess());

    toast.success('Tạo tài khoản thành công');

    if (callback) callback();
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionCreateInternalAccountFailed());
  }
}

function* updateInternalAccount({ payload }) {
  const { accountInfo, callback } = payload;
  try {
    yield manageAccountApi.updateInternalAccount(accountInfo);
    yield put(actionUpdateInternalAccountSuccess());

    toast.success('Cập nhật tài khoản thành công');

    if (callback) callback();
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionUpdateInternalAccountFailed());
  }
}

function* getInternalAccountDetail({ payload }) {
  try {
    const response = yield manageAccountApi.detailInternalAccount(payload);
    yield put(actionGetInternalAccountDetailSuccess(response.payload));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionGetInternalAccountDetailFailed());
  }
}

function* deleteInternalAccount({ payload }) {
  const { id, callback } = payload;
  try {
    yield manageAccountApi.deleteInternalAccount(id);
    yield put(actionDeleteInternalAccountSuccess());

    toast.success('Xóa tài khoản thành công');

    if (callback) callback();
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionDeleteInternalAccountFailed());
  }
}

export default function* manageAccountSaga() {
  yield takeLeading(GET_INTERNAL_ACCOUNT_LIST, getInternalAccountList);
  yield takeLeading(CREATE_INTERNAL_ACCOUNT, createInternalAccount);
  yield takeLeading(UPDATE_INTERNAL_ACCOUNT, updateInternalAccount);
  yield takeLeading(GET_INTERNAL_ACCOUNT_DETAIL, getInternalAccountDetail);
  yield takeLeading(DELETE_INTERNAL_ACCOUNT, deleteInternalAccount);
}
